<template>
  <div>
    <div v-if="value !== undefined">
      <!-- @slot Use this slot to place text when the boolean value is true -->
      <slot v-if="value === true" name="true">
        {{ $t('common.yes')}}
      </slot>
      <!-- @slot Use this slot to place text when the boolean value is false -->
      <slot v-if="value === false" name="false">
        {{ $t('common.no')}}
      </slot>
    </div>
    <v-skeleton-loader
      v-else
      type="text"
      class="mx-auto"
    />
  </div>
</template>

<script>
/**
  * Outputs text based on a boolean value
  */
export default {
  name: 'BoolField',
  props: {
    /**
     * This is the boolean value used to switch the text
     */
    value: {
      type: Boolean,
      default: undefined,
    },
  },
};
</script>

<docs>
## Example

```html
<aurora-bool-field v-model="boolValue">
  <span v-slot:true>
    Yes
  </span>
  <span v-slot:false>
    Yes
  </span>
</aurora-bool-field>
```
</docs>
